<div class="bg-white h-[200px] py-4 px-8 rounded-md">
  <div class="flex h-full flex-col justify-center gap-4">
    <h1 class="text-xl">
      {{ data.message }}
    </h1>
    <div class="flex justify-around mt-2">
      <button
        type="button"
        (click)="dialogRef.close()"
        ui-admin-button
        color="danger-outlined"
      >
        No
      </button>
      <button
        (click)="handleConfirmed()"
        type="button"
        ui-admin-button
        color="accent-outlined"
      >
        Yes
      </button>
    </div>
  </div>
</div>
